import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import client from '../api/client';
import Layout from '../components/Layout';
import './Dashboard.css';

const ACTION_COLOR = {
  'job.created':          '#3b82f6',
  'job.updated':          '#3b82f6',
  'job.deleted':          '#ef4444',
  'job.completed':        '#22c55e',
  'department.created':   '#22c55e',
  'department.deleted':   '#ef4444',
  'inventory.scanned':    '#f59e0b',
  'inventory.updated':    '#f59e0b',
  'floor_audit.started':  '#8b5cf6',
  'floor_audit.completed':'#22c55e',
  'user.created':         '#14b8a6',
  'user.updated':         '#14b8a6',
};

const QUICK_ACTIONS = [
  { label: 'New Job',       path: '/jobs',           action: 'new'  },
  { label: 'Add Inventory', path: '/inventory',      action: 'new'  },
  { label: 'Start Audit',   path: '/floor-audit'                    },
  { label: 'View Queue',    path: '/queue'                          },
  { label: 'Kiosk Settings',path: '/settings/kiosk'                },
  { label: 'Locations',     path: '/locations'                      },
];

export default function Dashboard() {
  const { org }               = useAuth();
  const navigate              = useNavigate();
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await client.get('/reports/summary');
        setSummary(res.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) return <Layout><div style={{color:'#6b7280'}}>Loading...</div></Layout>;

  return (
    <Layout>
      {/* Stats */}
      <div className="dash-stats">
        <div className="stat">
          <div className="stat-label">Total Jobs</div>
          <div className="stat-value">
            {summary?.jobs?.reduce((sum, j) => sum + parseInt(j.count), 0) || 0}
          </div>
          <div className="stat-sub">
            {summary?.jobs?.map(j => `${j.count} ${j.status}`).join(' · ') || '--'}
          </div>
        </div>
        <div className="stat">
          <div className="stat-label">Inventory Items</div>
          <div className="stat-value">{summary?.inventory?.total_items || 0}</div>
          <div className="stat-sub">{summary?.inventory?.total_quantity || 0} units total</div>
        </div>
        <div className="stat">
          <div className="stat-label">Active Locations</div>
          <div className="stat-value">{summary?.locations?.total || 0}</div>
          <div className="stat-sub">tracked across the floor</div>
        </div>
        <div className="stat">
          <div className="stat-label">Never Scanned</div>
          <div className="stat-value amber">{summary?.inventory?.never_scanned || 0}</div>
          <div className="stat-sub">
            {summary?.inventory?.never_scanned === 0 ? 'all items counted' : 'missing confirmation'}
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="dash-section-label">Quick Actions</div>
      <div className="dash-quick-row">
        {QUICK_ACTIONS.map(({ label, path }) => (
          <button
            key={path + label}
            className="dash-quick-pill"
            onClick={() => navigate(path)}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Recent Activity */}
      <div className="dash-section-label" style={{marginTop:'32px'}}>Recent Activity</div>
      <div className="dash-activity">
        {(!summary?.recent_activity || summary.recent_activity.length === 0) && (
          <div className="dash-empty">No activity yet</div>
        )}
        {summary?.recent_activity?.map((a, i) => (
          <div key={i} className="dash-activity-row">
            <div className="dash-activity-left">
              <div
                className="dash-activity-dot"
                style={{ background: ACTION_COLOR[a.action] || '#4b5563' }}
              />
              <div className="dash-activity-action">{a.action}</div>
            </div>
            <div className="dash-activity-meta">
              {a.user_email} &nbsp;·&nbsp; {new Date(a.created_at).toLocaleString()}
            </div>
          </div>
        ))}
      </div>
    </Layout>
  );
}